import React from 'react'

interface InputErrorText {
  text: string
}
export default function InputErrorText(props: InputErrorText) {
  const { text } = props

  return (
    <div
      className="mt1"
      style={{
        color: 'red',
        display: text !== '' ? 'block' : 'none',
        fontSize: '12px',
      }}
    >
      {text}
    </div>
  )
}
